export interface ParticipantHoleScore {
    type: ParticipantHoleScoreType
}

export enum ParticipantHoleScoreType {
    StrokePlayNoScore = "StrokePlayScore.NoScore",
    StrokePlayPickUp = "StrokePlayScore.PickUp",
    StrokePlayScore = "StrokePlayScore.Score",
    StablefordScore = "StablefordScore"
}

export interface StrokePlayScore extends ParticipantHoleScore {
    value: number
}

export interface StablefordScore extends ParticipantHoleScore {
    points: number | null
}
